import useTranslator from "../../hooks/useTranslator";
import { Button, Card } from "../design";

const AssignPropertyStart = (props) => {
  const { handleNextStep } = props;
  const { _t } = useTranslator();

  // the three steps of the flow, in order
  const steps = [
    { img: "/images/stepone-img.svg", text: _t("addRentalDetails") },
    { img: "/images/steptwo-img.svg", text: _t("sendToTenant") },
    { img: "/images/Circle.svg", text: _t("tenantSetUpPayment") },
  ];

  return (
    <>
      <header className="assign-page__head">
        <h1>{_t("whatDoINeedToGetSetUp")}</h1>
        <p>{_t("assignPropertyStartSubtitle")}</p>
      </header>
      <Card>
        <ol className="assign-steps">
          {steps.map((step) => (
            <li key={step.img} className="assign-step">
              <img src={step.img} alt="" />
              <p>{step.text}</p>
            </li>
          ))}
        </ol>
        <div className="assign-actions">
          <Button size="lg" onClick={handleNextStep}>
            {_t("getStarted")}
          </Button>
        </div>
      </Card>
    </>
  );
};

export default AssignPropertyStart;
